<template>
  <b-modal
    id="activate-campaign-package-modal"
    :modal-class="'default-modal'"
    :hide-footer="true"
  >
    <AlertWraper
    :content="content"
    :type="content_type"
    />
    <div class="text-center mt-3">
      <div class="mb-4">
        <i class="fa fa-warning font-size-large text-warning"></i>
      </div>
      <h2 class="highlighted-color1">
        <span>{{ $t('activate_package') }}</span>
      </h2>
      <p v-html="$t('want_to_activate_campaign_group', {name: this.segmentation ? this.segmentation.name : ''})"></p>
      <p>{{ $t('this_action_will_activate_all_strategies') }}</p>
      <div class="mt-3">
        <!-- MESSAGES -->
        <div
          class="mb-2 alert-message-card text-color2 font-size-small px-3 py-2"
          v-if="loader"
        >
          <p
            class="mb-0"
          >
            {{ $t('this_action_may_take_a_few_minutes') }}
          </p>
        </div> <!-- END MESSAGES -->
        <Button
          type="button"
          class="btn btn-color10"
          @click="submit"
          :loading="loader"
        >
          {{ $t('activate_package') }}
        </Button>
      </div>
    </div>
  </b-modal>
</template>

<script>

import CampaignPackagesService from '@/modules/campaigns/services/campaign-packages-service'
import NotificationService from '@/modules/notifications/services/notifications-service'
import { parseErrorResponseToArray } from '@/utils'

import AlertWraper from '@/components/common/Alert/AlertWraper'
import Button from '@/components/common/Button/Button'

export default {
  name: 'ActivateCampaignPackageModal',
  props: ['campaign', 'segmentation'],
  components: {
    AlertWraper,
    Button
  },
  data () {
    return {
      loader: false,
      content: null,
      content_type: 'error'
    }
  },
  methods: {
    /**
     * Submit
     */
    async submit () {
      this.loader = true
      try {
        await CampaignPackagesService.activateCampaignPackage(this.segmentation.id)
        const notification = {
          notification: {
            type: 'success',
            content: this.$t('campaign_group_successfully_activated')
          }
        }
        NotificationService.createGlobalSuccessNotification(notification)
        this.$bvModal.hide('activate-campaign-package-modal')
        this.$emit('package-activated', this.campaign)
      } catch (error) {
        this.content = parseErrorResponseToArray(error)
      }
      this.loader = false
    }
  }
}
</script>
